import { apiClient, type SubPartnerExEntity } from '@/libs/api'

export type FetchSubPartnerDetailQuery = {
  tenantKey: string
  subPartnerId: number
}

export type FetchSubPartnerDetailResponse = SubPartnerExEntity

export const fetchSubPartnerDetail = async (
  { tenantKey, subPartnerId }: FetchSubPartnerDetailQuery,
  signal?: AbortSignal
): Promise<FetchSubPartnerDetailResponse> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .sub_partners._id(subPartnerId)
    .$get({
      config: {
        signal
      }
    })
  return data
}
